import { render, staticRenderFns } from "./GifSelectorDrawer.vue?vue&type=template&id=51aef2e2"
import script from "./GifSelectorDrawer.vue?vue&type=script&lang=js"
export * from "./GifSelectorDrawer.vue?vue&type=script&lang=js"
import style0 from "./GifSelectorDrawer.vue?vue&type=style&index=0&id=51aef2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,Spinner: require('/skade-pwa/components/ui/atom/Spinner.vue').default})
